import { render, staticRenderFns } from "./BasicStackedAreaGraph.vue?vue&type=template&id=3c27d445"
import script from "./BasicStackedAreaGraph.vue?vue&type=script&lang=js"
export * from "./BasicStackedAreaGraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports